/**
 * Created by laszlo.czondor on 2017. 11. 28.
 * https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
 */

const RADIUS = 6371000; // Earth radius in meters
const DEGREE_TO_RADIAN_CONVERSION_NUMBER = Math.PI / 180;

function degreesToRadian(degree) {
	return degree * DEGREE_TO_RADIAN_CONVERSION_NUMBER;
}

function distance(coordinate1, coordinate2) {
	let halfTheDistanceOfLatitudes = degreesToRadian(coordinate2.lat - coordinate1.lat) / 2;
	let halfTheDistanceOfLongitudes = degreesToRadian(coordinate2.lng - coordinate1.lng) / 2;
	let angle =
		Math.sin(halfTheDistanceOfLatitudes) * Math.sin(halfTheDistanceOfLatitudes) +
		Math.cos(degreesToRadian(coordinate1.lat)) * Math.cos(degreesToRadian(coordinate2.lat)) *
		Math.sin(halfTheDistanceOfLongitudes) * Math.sin(halfTheDistanceOfLongitudes)
	;
	let curve = 2 * Math.atan2(Math.sqrt(angle), Math.sqrt(1 - angle));
	let distance = RADIUS * curve; // distance in m
	return distance;
}

export default distance;



// WEBPACK FOOTER //
// ../source/common/maps/distance-between-two-coordinates.js